import {PaginationParams} from "./../../helpers/api";
import http from "../../common/services/httpService";
import {Api, apiUrls, SortingAndFilteringParams} from "../../helpers/api";
import {AxiosResponse} from "axios";
import {PageableModel} from "../../common/models/table";
import {
    GeneralDeclarationDataForFileModel,
    GeneralDeclarationDetailsModel,
    GeneralDeclarationModel,
    GeneralDeclarationFilters
} from "../models/generalDeclaration";

export class GeneralDeclarationService {
    private static generalDeclaration = apiUrls.documents.generalDeclaration;

    public static async getAll(filters: GeneralDeclarationFilters, paginationParams: PaginationParams, sortingAndFilteringParams: SortingAndFilteringParams): Promise<AxiosResponse<PageableModel<GeneralDeclarationModel>>> {
        sortingAndFilteringParams.filterCondition = `${this.getQuery(filters)}`;

        const url = Api.addSortingAndFilteringParams(Api.getUrl(this.generalDeclaration), sortingAndFilteringParams);
        return await http.get<PageableModel<GeneralDeclarationModel>>(`${Api.addPaginationParams(url, paginationParams)}`);
    }

    public static async getGeneralDeclaration(id: string): Promise<AxiosResponse<GeneralDeclarationDetailsModel>> {
        return await http.get(`${Api.getUrl(this.generalDeclaration)}/${id}`);
    }

    public static async getGeneralDeclarationDataForFile(id: string): Promise<AxiosResponse<GeneralDeclarationDataForFileModel>> {
        return await http.get(`${Api.getUrl(this.generalDeclaration)}/${id}/file`);
    }

    private static getQuery(filters: GeneralDeclarationFilters) {
        const arrivalDepartureTime = filters.arrivalDepartureTime && `${filters.arrivalDepartureTime},`;
        const type = filters.type && `directionType::${(filters.type)},`;
        const shipowner = filters.shipownerId && `shipowner.entityId::${filters.shipownerId},`;
        const ferry = filters.ferryId && `ferryEntityId::${filters.ferryId},`;

        return arrivalDepartureTime + type + shipowner + ferry;
    }
}
